module.exports = __webpack_public_path__ + "img/pluspay.87e2b925.png";